<template>
  <div class="font-loading-status" v-if="showStatus">
    <div class="status-card">
      <h3>字体加载状态</h3>
      <div class="status-item">
        <span class="label">阿里普惠字体:</span>
        <span :class="['status', alibabaLoaded ? 'success' : 'error']">
          {{ alibabaLoaded ? '✅ 已加载' : '❌ 未加载' }}
        </span>
      </div>
      <div class="status-item">
        <span class="label">字体策略:</span>
        <span class="status">{{ fontStrategy }}</span>
      </div>
      <div class="status-item">
        <span class="label">设备类型:</span>
        <span class="status">{{ deviceType }}</span>
      </div>
      <button @click="checkStatus" class="refresh-btn">
        刷新状态
      </button>
      <button @click="runDebug" class="debug-btn">
        调试字体
      </button>
    </div>
  </div>
</template>

<script>
import { fontLoader } from '@/utils/fontLoader.js'
import { fontDebugger } from '@/utils/fontDebugger.js'

export default {
  name: 'FontLoadingStatus',
  data() {
    return {
      alibabaLoaded: false,
      fontStrategy: '',
      deviceType: '',
      showStatus: process.env.NODE_ENV === 'development'
    }
  },
  mounted() {
    this.checkStatus()
  },
  methods: {
    async checkStatus() {
      try {
        this.alibabaLoaded = await fontLoader.checkFontLoaded('Alibaba PuHuiTi')
        this.fontStrategy = '统一使用阿里普惠字体'
        this.deviceType = fontLoader.isMobile ? '移动端' : '桌面端'
      } catch (error) {
        console.error('字体状态检查失败:', error)
        this.alibabaLoaded = false
      }
    },
    async runDebug() {
      try {
        await fontDebugger.generateDebugReport()
      } catch (error) {
        console.error('字体调试失败:', error)
      }
    }
  }
}
</script>

<style scoped>
.font-loading-status {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}

.status-card {
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  min-width: 250px;
}

.status-card h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.status-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.label {
  font-size: 14px;
  color: #666;
}

.status {
  font-size: 14px;
  font-weight: 500;
}

.status.success {
  color: #67C23A;
}

.status.error {
  color: #F56C6C;
}

.refresh-btn, .debug-btn {
  background: #409EFF;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  margin-right: 8px;
  margin-top: 10px;
}

.refresh-btn:hover, .debug-btn:hover {
  background: #337ecc;
}

.debug-btn {
  background: #E6A23C;
}

.debug-btn:hover {
  background: #d49426;
}
</style> 